// src/pages/suppliers/SuppliersTable.jsx
import React, { useMemo, useEffect } from "react";
import { App, FloatButton, Popconfirm } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useUI } from "@/context/UIContext";

import MobileCategories from "@/components/MobileCategories.jsx";
import FlatRow from "@/components/FlatRow.jsx";
import { Drawer, Space, Button } from "antd";
import useSuppliers from "./hooks/useSuppliers";
import useSupplierForm from "./hooks/useSupplierForm";
import SupplierForm from "./components/SupplierForm";

export default function SuppliersTable() {
  const { message } = App.useApp();
  const { data = [], loading, reload, create, update, remove } = useSuppliers();
  const { searchQuery, setHeaderTitle } = useUI();

  const {
    form, open, title, onCreate, onEdit, onClose, onSubmit, submitting, editingId,
  } = useSupplierForm({ create, update, reload, message });

  useEffect(() => {
    setHeaderTitle("Постачальники");
    return () => setHeaderTitle("WHFOF");
  }, [setHeaderTitle]);

  const dataSource = useMemo(() => {
    const q = (searchQuery || "").trim().toLowerCase();
    return q ? data.filter((x) => (x.name || "").toLowerCase().includes(q)) : data;
  }, [data, searchQuery]);

  const getId = (arg) => (typeof arg === "string" ? arg : arg?._id ?? arg?.id ?? null);

  const doDelete = async (id) => {
    try {
      await remove(id);
      await reload();
      if (open && id === editingId) onClose();
      message.success("Постачальника видалено");
    } catch {
      message.error("Не вдалося видалити постачальника");
    }
  };

  const handleDelete = (arg) => {
    const id = getId(arg);
    if (!id) {
      message.error("Не знайдено ідентифікатор постачальника");
      return;
    }
    doDelete(id);
  };

  const FlatRowWithEdit = (props) => (
    <div onClick={() => onEdit(props.item)}>
      <FlatRow {...props} />
    </div>
  );

  return (
    <>
      <MobileCategories
        mode="flat"
        RowComponent={FlatRowWithEdit}
        loading={loading}
        dataSource={dataSource}
      />

      <Drawer
        title={title}
        onClose={onClose}
        open={open}
        placement="right"
        width={360}
        destroyOnClose
        maskClosable={false}
        keyboard={false}
        forceRender
        bodyStyle={{ paddingBottom: 8 }}
        footer={
          <Space style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
            {editingId ? (
              <Popconfirm
                title="Видалити постачальника?"
                description="Цю дію неможливо скасувати."
                okText="Видалити"
                cancelText="Скасувати"
                okButtonProps={{ danger: true }}
                onConfirm={() => handleDelete(editingId)}
              >
                <Button danger icon={<DeleteOutlined />} disabled={submitting}>
                  Видалити
                </Button>
              </Popconfirm>
            ) : <span />}

            <Space>
              <Button onClick={onClose} disabled={submitting}>Скасувати</Button>
              <Button type="primary" onClick={onSubmit} loading={submitting}>
                Зберегти
              </Button>
            </Space>
          </Space>
        }
      >
        <SupplierForm form={form} />
      </Drawer>

      <FloatButton
        icon={<PlusOutlined />}
        type="primary"
        shape="circle"
        tooltip="Додати постачальника"
        onClick={onCreate}
        style={{
          right: 16,
          bottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
          boxShadow: "0 10px 24px rgba(0,0,0,.18)",
        }}
      />
    </>
  );
}
